import type { ToolUIPart } from 'ai';

import type { MessagePart } from './types';
import { isDynamicToolPart, isStaticToolPart } from './types';

export function getToolNameFromToolPart(toolPart: ToolUIPart): string {
  const direct = (toolPart as unknown as { toolName?: string }).toolName;
  if (direct) {
    return direct;
  }
  return toolPart.type.startsWith('tool-') ? toolPart.type.slice('tool-'.length) : toolPart.type;
}

export function getToolNameFromMessagePart(part: MessagePart): string | undefined {
  if (isDynamicToolPart(part)) {
    return part.toolName;
  }
  if (isStaticToolPart(part)) {
    return getToolNameFromToolPart(part as unknown as ToolUIPart);
  }
  return undefined;
}

export function getToolNameAndOutputFromMessagePart(
  part: MessagePart
): { toolName: string; output: unknown } | undefined {
  if (isDynamicToolPart(part)) {
    return part.state === 'output-available'
      ? { toolName: part.toolName, output: part.output }
      : undefined;
  }

  if (isStaticToolPart(part)) {
    const toolPart = part as unknown as ToolUIPart;
    const toolName = getToolNameFromToolPart(toolPart);
    return toolPart.state === 'output-available'
      ? { toolName, output: toolPart.output }
      : undefined;
  }

  return undefined;
}
